
// lazy-scripts.js
(function(){
  function loadScript(src, attrs){
    return new Promise(function(resolve,reject){
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      if (attrs) Object.keys(attrs).forEach(function(k){ s.setAttribute(k, attrs[k]); });
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function loadTagged(){
    document.querySelectorAll('script[data-src][data-lazy]:not([data-loaded])').forEach(function(tag){
      var src = tag.getAttribute('data-src');
      var lazy = tag.getAttribute('data-lazy');
      var parts = lazy.split(':');
      var mode = parts[0];
      var arg = parts.slice(1).join(':') || '';

      function doit(){ tag.setAttribute('data-loaded',''); loadScript(src); }

      if (mode === 'idle'){
        if ('requestIdleCallback' in window){
          requestIdleCallback(doit, {timeout: 2500});
        } else {
          setTimeout(doit, 1500);
        }
      } else if (mode === 'delay'){
        var ms = parseInt(arg || '20000', 10);
        setTimeout(doit, ms);
      } else if (mode === 'view'){
        var sel = arg || '#loox-reviews,.loox-reviews';
        var el = document.querySelector(sel);
        if (el && 'IntersectionObserver' in window){
          var io = new IntersectionObserver(function(entries, obs){
            entries.forEach(function(e){ if (e.isIntersecting){ doit(); obs.disconnect(); }});
          }, { rootMargin: '200px' });
          io.observe(el);
        } else {
          if ('requestIdleCallback' in window) requestIdleCallback(doit, {timeout: 2500}); else setTimeout(doit, 1500);
        }
      } else {
        if ('requestIdleCallback' in window) requestIdleCallback(doit, {timeout: 2500}); else setTimeout(doit, 1500);
      }
    });
  }
  document.addEventListener('DOMContentLoaded', loadTagged);
  setTimeout(loadTagged, 3000);
})();
